// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-webinars-components-ChatInactive-style__wrapper_03k9q"};